// extracted by mini-css-extract-plugin
export default {"container":"payment-cell_container__+WXyS"};